import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import { PageTitle, TableButtons, Table } from '../../../components';
import { Filters } from '../../../services/';
import _ from 'lodash';
import 'react-table-6/react-table.css'
import { loadCustomers, loadInactiveCustomers, setMessagesRecipients } from '../../../redux';

import './CustomersList.css';

const CustomersList = props => {
    const { t }    = useTranslation();
    const history  = useHistory();
    const dispatch = useDispatch();

    const [selection, setSelection] = useState([]);

    const { customers } = useSelector(state => state.customers);

    useEffect(() => {
        // Load customers
        dispatch(loadCustomers());
    }, [dispatch]);

    const tableCustomers = customers?.map(customer => ({
        ...customer,
        fullname: _.filter([customer.contact.firstname, customer.contact.lastname]).join(' ')
    }));

    const isSelected = React.useCallback(_id => selection.includes(_id), [ selection ]);
    const onChangedCheckbox = _id => {
        if (isSelected(_id))
            setSelection(selection.filter(i => i !== _id));
        else
            setSelection([...selection, _id]);
    };
    const selectAll = React.useCallback(all => {
        setSelection(all ?
            customers?.map(t => t._id) :
            []
        );
    }, [customers]);
    const allSelected = useMemo(() => {
        if (!customers?.length || !selection?.length)
            return false;

        if (customers.length !== selection?.length)
            return false;

        return customers.reduce(
            (allSelected, customer) => allSelected && selection.includes(customer._id),
            true
        );
    }, [customers, selection]);

    const sendBatchEmail = () => {
        const recipients = selection?.map(_id => {
            const customer = customers?.find(t => t._id === _id);
            if (!customer?.contact.email)
                return null;

            return {
                to: {
                    name: [
                        customer.contact?.firstname,
                        customer.contact?.lastname
                    ].filter(Boolean).join(' ') || t.contact?.email,
                    address: customer.contact.email
                },
                context: {
                    user_id: customer._id
                }
            };
        }).filter(Boolean);
        dispatch(setMessagesRecipients(recipients));
        history.push('/messages');
    }


    let columns = [{
        Header: cell => (
            <input
                className="checkbox"
                type="checkbox"
                checked={!!allSelected}
                onChange={() => selectAll(!allSelected)}
                value={cell.value}
            />
        ),
        filterable: false,
        sortable: false,
        accessor: '_id',
        maxWidth: 90,
        className: "checkbox-cell",
        Cell: cell => (
            <input
                className="checkbox"
                type="checkbox"
                checked={isSelected(cell.value)}
                onChange={() => onChangedCheckbox(cell.value)} value={cell.value}
            />
                )
    }, {
        Header: t('customers.name'),
        accessor: "name",
        filterMethod: Filters.textFilterMethod("name"),
        Filter: Filters.textFilter,
        filterAll: true,
    }, {
        Header: t('customers.fullname'),
        accessor: "fullname",
        filterMethod: Filters.textFilterMethod("fullname"),
        Filter: Filters.textFilter,
        filterAll: true,
    }];

    columns = columns.concat([{
        Header: t('common.actions'),
        accessor: "_id",
        maxWidth: 110,
        filterable: false,
        Cell: row => (
            <TableButtons
                id={row.value}
                actions={['show', 'edit', 'delete']}
                module="customers"
            />
        )
    }]);

    return (
        <div className="CustomersList">
            <PageTitle icon="users" title={t('common.customer', {count: 42})} actions={[]} />
            {selection?.length > 0 && (
                <div className="border rounded d-flex p-1 mb-1 justify-start">
                    <Button onClick={ sendBatchEmail } color="primary">
                        <i className="fa fa-envelope" />&nbsp;
                        { t('tickets.batch.send_email') }
                    </Button>
                </div>
            )}
            <Table id="customersTable" data={ tableCustomers } columns={ columns } />
        </div>
    );
}

export default CustomersList;
